import { inheritsLoose as _inheritsLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import { withTheme } from 'styled-components';

var SpinningCircle = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SpinningCircle, _Component);
  function SpinningCircle(props) {
    var _props$r, _props$arcs;
    var _this;
    _this = _Component.call(this, props) || this;
    _this._start = null;
    _this._stop = false;
    _this._spinCircle = function (timestamp) {
      if (!_this._stop) {
        var _this$props$period;
        if (!_this._start) {
          _this._start = timestamp;
        }
        var progress = timestamp - _this._start;
        var c = _this.state.circleCircumference;
        _this.setState({
          // Moving from 0 and c, every period
          strokeDashoffset: progress / ((_this$props$period = _this.props.period) !== null && _this$props$period !== void 0 ? _this$props$period : SpinningCircle.defaultProps.period) * c % c
        });
        window.requestAnimationFrame(_this._spinCircle);
      }
    };
    var r = (_props$r = props.r) !== null && _props$r !== void 0 ? _props$r : SpinningCircle.defaultProps.r;
    var _c = Math.PI * r * 2;
    _this.state = {
      circleRadius: r,
      circleCircumference: _c,
      strokeDasharray: _c / (((_props$arcs = props.arcs) !== null && _props$arcs !== void 0 ? _props$arcs : SpinningCircle.defaultProps.arcs) * 2),
      strokeDashoffset: 2
    };
    return _this;
  }
  var _proto = SpinningCircle.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this._start = null;
    this._stop = false;
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(this._spinCircle);
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this._stop = true;
  };
  _proto.render = function render() {
    var _this$props = this.props,
      cx = _this$props.cx,
      cy = _this$props.cy,
      color = _this$props.color,
      strokeWidth = _this$props.strokeWidth,
      theme = _this$props.theme;
    var _this$state = this.state,
      circleRadius = _this$state.circleRadius,
      strokeDasharray = _this$state.strokeDasharray,
      strokeDashoffset = _this$state.strokeDashoffset;
    return /*#__PURE__*/React.createElement("circle", {
      cx: cx,
      cy: cy,
      r: circleRadius,
      fill: "transparent",
      stroke: color || theme.constellation.colors.blue500,
      strokeWidth: strokeWidth,
      strokeDasharray: strokeDasharray,
      style: {
        strokeDashoffset: strokeDashoffset
      }
    });
  };
  return SpinningCircle;
}(Component);
SpinningCircle.defaultProps = {
  className: 'rd3-linechart-spinning-circle',
  r: 10,
  strokeWidth: '3px',
  arcs: 8,
  period: 2000
};
var SpinningCircle$1 = withTheme(SpinningCircle);

export { SpinningCircle$1 as default };
